import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal,
  Backdrop,
  Typography,
  TextField,
  Button,
  Slide,
} from "@material-ui/core";

import { shouldOpenModal } from "../../redux/selectors";
import {
  openModalDatos,
  guardarDatosContacto,
} from "../../redux/actions/modalActions";
import styles from "./styles.styles";

export default () => {
  const classes = styles();
  const dispatch = useDispatch();
  const isModalOpen = useSelector((state) => shouldOpenModal(state));

  const [email, handleEmailChange] = useState<string>("");
  const [emailError, isEmailError] = useState<boolean>(false);

  const [telefono, handleTelefonoChange] = useState<string>("");
  const [telefonoError, isTelefonoError] = useState<boolean>(false);

  const [saveButtonDisabled, isDisabled] = useState<boolean>(true);

  const handleClose = () => dispatch(openModalDatos(false));

  const validateEmail = (email : string) => {
    handleEmailChange(email);
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    isEmailError(!re.test(email.toLowerCase()));
    isDisabled(!re.test(email.toLowerCase()) || telefonoError);
  };

  const validateTelefono = (telefono : string) => {
    handleTelefonoChange(telefono);
    isTelefonoError(Number.isNaN(telefono));
    isDisabled(emailError || Number.isNaN(telefono) || telefono === '');
  };

  const saveContacto = () => {
    dispatch(guardarDatosContacto({ email, telefono }));
    handleClose();
  };

  return (
    <Modal
      open={isModalOpen}
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      className={classes.modal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{ timeout: 500 }}
    >
      <Slide direction="down" in={isModalOpen} mountOnEnter unmountOnExit>
        <div className={classes.modalBody}>
          <Typography
            id="transition-modal-title"
            className={classes.modalTitle}
          >
            Por favor completá al menos uno de los campos:
          </Typography>
          <div id="transition-modal-description" className={classes.modalForm}>
            <TextField
              id="textfield-telefono"
              label="Teléfono"
              variant="outlined"
              className={classes.modalTextField}
              onChange={(e) => validateTelefono(e.target.value)}
              value={telefono}
              error={telefonoError}
              helperText={telefonoError ? "Teléfono inválido" : ""}
            />
            <TextField
              id="textfield-email"
              label="Email"
              variant="outlined"
              className={classes.modalTextField}
              onChange={(e) => validateEmail(e.target.value)}
              value={email}
              error={emailError}
              helperText={emailError ? "Mail inválido" : ""}
            />
            <Button
              variant="contained"
              color="primary"
              disabled={saveButtonDisabled}
              onClick={() => {
                saveContacto();
              }}
            >
              Guardar
            </Button>
          </div>
        </div>
      </Slide>
    </Modal>
  );
};
